import { Suspense, type ReactNode } from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

/** What shows while a page or tab's code arrives (NFR-04, docs §169): pages load when first opened. */
export function PageLoading() {
  return (
    <Box role="status" aria-label="Loading" sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
      <CircularProgress />
    </Box>
  );
}

export function Loadable({ children }: { children: ReactNode }) {
  return <Suspense fallback={<PageLoading />}>{children}</Suspense>;
}
